export function signInRequest(email, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { email, password },
  };
}

export function signInSuccess(token, user, modules, configs, lang) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user, modules, configs, lang },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function teoPresentationViewed() {
  return {
    type: '@user/TEO_PRESENTATION_VIEWED',
  };
}
